import { render, staticRenderFns } from "./enterpriseResourceAssignment.vue?vue&type=template&id=e5f66ed6&scoped=true&"
import script from "./enterpriseResourceAssignment.vue?vue&type=script&lang=js&"
export * from "./enterpriseResourceAssignment.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseResourceAssignment.vue?vue&type=style&index=0&id=e5f66ed6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f66ed6",
  null
  
)

export default component.exports